import React from "react";
import styled from "styled-components";
import {
  ElementContainer,
  FlexibleContainer,
} from "../containers/styledComponents";
import {
  compassLightBlue,
  compassLightRed,
  compassYellowBackground,
  lightGreys,
} from "../../styles";
import { Icon, IconContainer } from "./styledComponents";
import { FLAG_MAP } from "./StatusFlag";
import { FlagColor, FlagStatus } from "../../enums/Status";
import { CompassParagraph } from "../common/styledComponents";
import { FlagKey } from "../../models/workflowModels";
import { LoadingTableCell } from "../tables/LoadingTableCell";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/routeNames";

const StyledParagraph = styled(CompassParagraph)`
  &:hover {
    text-decoration: underline;
  }
`;

export interface FlagBoxItem {
  bg: string;
  icon: string;
  text: string;
}
const FLAG_KEY_TO_FLAG_BOX_DATA_MAPPING: Record<FlagKey, FlagBoxItem> = {
  [FlagKey.BLOCKED]: {
    bg: compassLightRed,
    icon: FLAG_MAP[FlagColor.RED],
    text: FlagStatus.BLOCKED,
  },
  [FlagKey.IN_PROGRESS]: {
    bg: compassYellowBackground,
    icon: FLAG_MAP[FlagColor.YELLOW],
    text: "Flagged",
  },
  [FlagKey.RESOLVED]: {
    bg: "#DDF6E8",
    icon: FLAG_MAP[FlagColor.GREEN],
    text: FlagStatus.RESOLVED,
  },
  [FlagKey.DEFAULT]: {
    bg: lightGreys.KPIBackground,
    icon: FLAG_MAP[FlagColor.WHITE],
    text: "Not Flagged",
  },
};

export const getFlagData = (flagKey: FlagKey | null): FlagBoxItem => {
  if (flagKey) {
    return (
      FLAG_KEY_TO_FLAG_BOX_DATA_MAPPING[flagKey] ||
      FLAG_KEY_TO_FLAG_BOX_DATA_MAPPING[FlagKey.DEFAULT]
    );
  }
  return FLAG_KEY_TO_FLAG_BOX_DATA_MAPPING[FlagKey.DEFAULT];
};

export const FlagBox = ({
  flagKey,
  isLoading = false,
}: {
  flagKey: FlagKey | null;
  isLoading?: boolean;
}): JSX.Element => {
  const flagFata = getFlagData(flagKey);
  const navigate = useNavigate();
  return (
    <FlexibleContainer ml={"18px"} mr={"12px"}>
      <ElementContainer
        p={1}
        bg={flagFata.bg}
        ai="center"
        br={6}
        isLoading={isLoading}
      >
        <IconContainer>
          <Icon src={flagFata.icon} />
        </IconContainer>
      </ElementContainer>
      {isLoading ? (
        <LoadingTableCell dark={true} ml={1} />
      ) : (
        <ElementContainer flexDirection="column">
          <CompassParagraph fontSize={15}>
            {getFlagData(flagKey).text}
          </CompassParagraph>
          <StyledParagraph
            color={compassLightBlue}
            fontSize={12}
            cursor="pointer"
            onClick={(): void => navigate(ROUTES.WORKSPACE)}
          >
            Go to workspace
          </StyledParagraph>
        </ElementContainer>
      )}
    </FlexibleContainer>
  );
};
